import { render, staticRenderFns } from "./QCPage.vue?vue&type=template&id=0a8785ab&scoped=true&"
import script from "./QCPage.vue?vue&type=script&lang=js&"
export * from "./QCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8785ab",
  null
  
)

export default component.exports